(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-offer-popup"]) return;
  try {
    
    class EmailOfferPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[ref="dialog"]');
        if (!this.dialog || !('showModal' in this.dialog)) return;
        this.key = this.dataset.key || 'sf-eop';
        this.freqDays = parseInt(this.dataset.frequencyDays, 10) || 7;

        this.formWrap = this.querySelector('[ref="formWrap"]');
        this.reveal = this.querySelector('[ref="reveal"]');
        this.form = this.querySelector('.eop__form');

        this.querySelector('[ref="close"]')?.addEventListener('click', () => this.dismiss());
        this.querySelector('[ref="dismiss"]')?.addEventListener('click', () => this.dismiss());
        // Click on the backdrop (outside the inner card) closes it.
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dismiss(); });
        this.querySelector('[ref="copy"]')?.addEventListener('click', () => this.copyCode());

        // Submit via fetch so the page never reloads. The old full-page POST made
        // Shopify reload anchored to the footer form — that was the "forced scroll
        // to the bottom" bug. No reload also lets us reveal the code inline.
        this.form?.addEventListener('submit', (e) => this.handleSubmit(e));

        // Fallback (no-JS submit reloaded the page): snap back to top, clean the
        // URL, and show the code state.
        if (new URLSearchParams(location.search).has('customer_posted')) {
          try { window.scrollTo(0, 0); history.replaceState(null, '', location.pathname); } catch (e) {}
          this.revealCode();
          this.open();
          this.remember();
          return;
        }

        if (this.shouldSuppress()) return;
        const delay = parseInt(this.dataset.delay, 10) || 3000;
        this.timer = setTimeout(() => this.open(), delay);
      }

      handleSubmit(e) {
        const email = this.form.querySelector('input[type="email"]');
        if (email && !email.checkValidity()) return; // let native validation surface
        e.preventDefault();
        try {
          fetch(this.form.action, {
            method: 'POST',
            body: new FormData(this.form),
            headers: { Accept: 'text/html' },
          }).catch(() => {});
        } catch (err) {}
        this.revealCode();
        this.remember();
      }

      revealCode() {
        if (this.formWrap) this.formWrap.hidden = true;
        if (this.reveal) this.reveal.hidden = false;
      }

      copyCode() {
        const code = this.reveal?.dataset.code || '';
        const label = this.querySelector('[ref="copyLabel"]');
        const wrap = this.querySelector('[ref="codeWrap"]');
        const done = () => {
          if (label) label.textContent = 'Copied';
          wrap?.classList.add('eop__code--copied');
          setTimeout(() => {
            if (label) label.textContent = 'Copy';
            wrap?.classList.remove('eop__code--copied');
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          done();
        }
      }

      disconnectedCallback() { clearTimeout(this.timer); }

      shouldSuppress() {
        try {
          const ts = parseInt(localStorage.getItem(this.key), 10);
          if (!ts) return false;
          return (Date.now() - ts) < this.freqDays * 86400000;
        } catch (e) { return false; }
      }

      remember() {
        try { localStorage.setItem(this.key, String(Date.now())); } catch (e) {}
      }

      open() { if (!this.dialog.open) this.dialog.showModal(); }

      dismiss() {
        this.remember();
        if (this.dialog.open) this.dialog.close();
      }
    }
    if (!customElements.get('email-offer-popup')) {
      customElements.define('email-offer-popup', EmailOfferPopup);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-shoppable"] && !Shopify.designMode) return;
  try {
    
  // Performance: reels never autoplay on load. A single IntersectionObserver
  // plays a reel when it is >= ~50% visible and pauses it when it leaves.
  // preload="none" keeps the video bytes from downloading until near viewport.
  (function () {
    if (window.__instagramShoppableReelsInit) return;
    window.__instagramShoppableReelsInit = true;

    var reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init() {
      // Respect reduced motion: do not auto-play. Poster stays; user taps to play.
      if (reduceMotion) {
        document
          .querySelectorAll('[data-reel-track] video.instagram-shoppable__video')
          .forEach(function (video) {
            video.setAttribute('controls', '');
            video.setAttribute('preload', 'none');
          });
        return;
      }

      if (!('IntersectionObserver' in window)) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              // Load + play only when sufficiently in view.
              if (video.preload === 'none') {
                video.preload = 'auto';
                video.load();
              }
              var playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function () {
                  /* autoplay rejected; leave paused */
                });
              }
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { threshold: [0, 0.5, 1] }
      );

      document
        .querySelectorAll('[data-reel-track] video.instagram-shoppable__video')
        .forEach(function (video) {
          observer.observe(video);
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
